import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar, MatDialogConfig } from '@angular/material';
import { ReservaData } from '@app/_models/reserva';
import { Reserva } from '@app/_models/reserva';
import { Match } from '@app/_models/match';
import { ReservasService } from '@app/services/reservas.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '@app/components/confirm-dialog/confirm-dialog.component';
import { SessionService } from '@app/services/session.service';
import { eReservetype } from '@app/_enums/reserve-type';
import { ReservaRecurrenteModalComponent } from '../reserva-recurrente-modal/reserva-recurrente-modal.component';
import { ReservaModalComponent } from '../reserva-modal/reserva-modal.component';

@Component({
  selector: 'app-reserva-dialog',
  templateUrl: './reserva-dialog.component.html',
  styleUrls: ['./reserva-dialog.component.scss']
})
export class ReservaDialogComponent implements OnInit {

  reserva: Reserva;
  guests: any;
  guests_total: number = 0;
  guests_conf: number = 0;
  after_total: number = 0;
  after_conf: number = 0;
  initializing: boolean = true;
  isEditable: boolean = false;
  matches: Match[] = [];
  typeName: string;
  currentDay: Date;

  constructor(
    public dialogRef: MatDialogRef<ReservaDialogComponent>,
    public dialogCancel: MatDialog,
    private reservasService: ReservasService,
    private session: SessionService,
    @Inject(MAT_DIALOG_DATA) public data: ReservaData,
    private _snackBar: MatSnackBar,
    public modalReserva: MatDialog,
  ) {
    this.reserva = data.reserva;
  }

  ngOnInit() {
    const now = new Date();
    const desde = new Date(this.reserva.start_time);
    if (desde > now && !this.reserva.tournament) {
      this.isEditable = true;
    }
    this.reservasService.getGuests(this.reserva.id)
      .subscribe(
        data => {
          this.handleDataInvitations(data);
        },
        error => console.log('error: ', error)
      );

    if (this.reserva.matches.length > 0) {
      for (let id of this.reserva.matches) {
        this.reservasService.getMatch(id)
          .subscribe(
            data => {          
              this.matches.push(data);
            },
            error => console.log('error: ', error)
          );
      }
    }

    this.getType();
  }

  getType() {
    const idType = this.reserva.reservation_type;
    const typeName = eReservetype[idType];
    this.typeName = typeName.replace(/_/g, ' ');
  }

  onNoClick(): void {
    this.dialogRef.close('no_refresh');
  }

  handleDataInvitations(data) {
    for (let item of data) {
      this.guests_total += 1;
      if (item.status_id == 1) { this.guests_conf += 1; };
      if (item.after_match_id == 1) { this.after_conf += 1; };
    }
    this.initializing = false;
  }

  confirmCancel(): void {
    const name = this.reserva.name ? this.reserva.name : this.reserva.planner;
    const message = `Está seguro que desea cancelar la reserva de ${name} ?`;
    var motivo = '';

    const isRecurrent = this.reserva.reservation_type == 2;

    const dialogData = new ConfirmDialogModel('Confirmación', message, true, 'Motivo', motivo, isRecurrent);

    const dialogRef = this.dialogCancel.open(ConfirmDialogComponent, {
      maxWidth: '500px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {

      if (dialogResult.result) {
        if (dialogResult.deleteGroup) {
          this.cancelReservaRecurrente();
        }else{
          this.cancelReserva(dialogResult.data);
        }
      }
    });
  }

  private cancelReserva(motivo: string = '') {
    const data = {
      user: this.session.currentUser.user,
      reason: motivo
    };
    this.reservasService.cancelReserva(this.reserva.id, data)
      .subscribe(
        data => {
          this.openSnackBar("Reserva cancelada");
          this.dialogRef.close('refresh');
        },
        error => {
          this.openSnackBar('Oops! ' + error);
        }
      );
  }

  private cancelReservaRecurrente() {

    const data = {
      id: this.reserva.reservation_group
    };
    
    this.reservasService.cancelReservaRecurrente(data)
      .subscribe(
        data => {
          this.openSnackBar("Grupo de Reservas canceladas");
          this.dialogRef.close('refresh');
        },
        error => {
          this.openSnackBar('Oops! ' + error);
        }
      );
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "", {
      duration: 2000
    });
  }

  
  updateReserve(idType: number) {
    const config = new MatDialogConfig();
    config.data = {
      reserva: {
        ...this.reserva,
      },
      updateReserva: true,
      day: this.currentDay
    };

    config.width = '600px';

    const modal = idType == eReservetype.Recurrentes ? this.modalReserva.open(ReservaRecurrenteModalComponent, config) :this.modalReserva.open(ReservaModalComponent, config);

    modal.afterClosed().subscribe((data: any) => {
      if (data) {
        this.currentDay = data;
        this.Refresh()
      }
    })

    this.dialogRef.close('refresh');
  }

  public Refresh() {
    var sec = this.currentDay.getSeconds();
    this.currentDay.setMinutes(sec + 1);
  }
}